import StylesSettings from "./StylesSettings";
import Box from "@mui/material/Box";
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import DraggableComponent from "../DraggableComponent"
import Paper from '@mui/material/Paper';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SubtitileStyles(props) {
  const { handlePlayingStatus, showSubtitleStyleBox, handleShowSubtitleStyleBox, handleFullScreen } = props;

  return (
    <DraggableComponent maxWidth={"100%"} >
      <Paper sx={{ display: showSubtitleStyleBox ? "block !important" : "none !important", width: "100%", position: "relative", textAlign: "justify", borderRadius: "10px", pb: 2 }}>
        <DialogContent>
          <StylesSettings handlePlayingStatus={handlePlayingStatus} handleShowSubtitleStyleBox={handleShowSubtitleStyleBox} handleFullScreen={handleFullScreen} />
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Paper>
    </DraggableComponent>
  );
}
